import styled, { css } from 'styled-components';
import { Link } from 'react-router';
import { breakpoints } from 'styles';

export const NavbarMargin = styled.div`
  width: 100%;
  height: 80px;

  @media (max-width: ${breakpoints.l}px) {
    height: 72px;
  }
`;

export const NavbarContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  margin: 0;
  width: 100%;
  height: 80px;
  padding-right: 24px;
  background-color: ${({ theme }) => theme.colors.surface};
  z-index: 2;

  @media (max-width: ${breakpoints.l}px) {
    height: 72px;
    padding-right: 8px;
  }
`;

export const NavbarInner = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  margin: 0 auto;
`;

export const MenuGrid = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 24px 48px;

  @media (max-width: ${breakpoints.s}px) {
    padding: 0 4px 48px;
  }
`;

const LinkBase = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  color: ${({ theme }) => theme.colors.grey6};
  font-size: 28px;
  font-weight: 700;
  border-radius: 16px;
  gap: 16px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.background};
  }

  @media (max-width: ${breakpoints.s}px) {
    font-size: 24px;
  }
`;

export const LinkRow = styled(Link)`
  ${LinkBase}

  &:hover {
    text-decoration: none;
  }
`;

export const ActionRow = styled.div`
  ${LinkBase}
`;

export const LinkExternal = styled.a`
  display: flex;
  padding: 8px 16px;
  color: ${({ theme }) => theme.colors.grey6};
  font-size: 18px;
  border-radius: 16px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.background};
  }

  @media (max-width: ${breakpoints.s}px) {
    font-size: 16px;
  }
`;

type NavbarColProps = {
  $alignRight?: boolean;
};

export const NavbarCol = styled.div<NavbarColProps>`
  display: flex;
  justify-content: ${({ $alignRight }) => ($alignRight ? 'right' : 'left')};
  align-items: center;
`;

export const LogoLink = styled(Link)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: fit-content;
  background-color: ${({ theme }) => theme.colors.primary};
  padding: 16px;
`;

export const Logo = styled.img`
  height: 48px;
  margin: auto 0;

  @media (max-width: ${breakpoints.l}px) {
    height: 40px;
  }
`;

export const ArrowIcon = styled.img`
  height: 16px;
`;
